import { observer } from "mobx-react";
import React, { useContext, useEffect, useLayoutEffect } from "react";
import { Title } from "@mantine/core";

import { Cubby } from "../stores/Cubby";

import {
  JsonView,
  allExpanded,
  collapseAllNested,
  darkStyles,
  defaultStyles,
} from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";

const JsonViewer = observer(({ cubby }: { cubby: Cubby }) => {
  return <></>;
});

export default JsonViewer;
